import fetchRequest from '../util/fetch'
import errUtil from '../util/error'

const query = `mutation ShiftPeriodCopy (
  $workspace: ID!,
  $period: PeriodInput!,
  $targetDates: [String!]!,
  $copyAssign: Boolean
) {
  shiftPeriodCopy (
    workspace: $workspace,
    period: $period,
    targetDates: $targetDates,
    copyAssign: $copyAssign
  ) {
    id
  }
}`

async function requestShiftPeriodCopy (variables, token) {
  const response = await fetchRequest({
    variables,
    query,
    token
  })
  if (!response) return errUtil.noResponse()

  const { errors, data } = response
  if (errors) {
    return errUtil.apiError('shift-period-copy', errors)
  }
  return data.shiftPeriodCopy
}

export default requestShiftPeriodCopy
